import { render, staticRenderFns } from "./ForumMeetings.vue?vue&type=template&id=06881550&scoped=true&"
import script from "./ForumMeetings.vue?vue&type=script&lang=js&"
export * from "./ForumMeetings.vue?vue&type=script&lang=js&"
import style0 from "./ForumMeetings.vue?vue&type=style&index=0&id=06881550&lang=scss&scoped=true&"
import style1 from "./ForumMeetings.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06881550",
  null
  
)

export default component.exports